// @flow

import React from 'react'
import type {Element} from 'react'

type AriaHiddenProps = {
  children?: ?Element<any>
}

export function AriaHidden(props: AriaHiddenProps) {
  return (
    <span aria-hidden>
      {props.children}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/AriaHidden/index.js